/**
 * @description [应用根主入口文件]
 * @date  2016-05-22
 */
import angular from 'angular'
import uiRouter from '@uirouter/angularjs'
import ngFileUpload from 'ng-file-upload'
import 'angular-tree-control/context-menu'
import treeControl from 'angular-tree-control'
// 第三方库
import nguitree from 'angular-ui-tree'
// 组件和页面入口
import components from 'components'
import factory from 'common/factory'
import services from 'common/services'
import { appConfig } from 'app/config'
import { remainCtrl } from 'redevConfig'
import "babel-polyfill"
let remainCtrlName = remainCtrl && remainCtrl.controllerName
const mainCtrl = remainCtrlName ? require(`redevelopment/${remainCtrlName}`).default : require('app/mainCtrl').default


// 统计中心
import statistics from 'app/statistics'
// 销项管理
import outputManage from 'app/outputManage'
// 系统管理
import system from 'app/system'
// 进项管理
import input from 'app/input'

// 登录首页和初始化
import main from 'app/main'
// 申报管理
import declaration from './app/declaration'
// 首页
import index from './app/index'

require('angular-ui-bootstrap')
require('common/global.js')
require('common/external.js')
// 样式
require('./assets/font/iconfont.css')
require('./assets/less1/index.less')

//二开公用方法、组件、样式
import redevServices from 'redevelopment/common/services'
import redevComponents from 'redevelopment/common/components'
require('redevelopment/less/index.less')
// 参数
// 定义模块
angular
    .module('app', [
        uiRouter,
        'ui.bootstrap',
        nguitree,
        treeControl,
        services,
        factory,
        ngFileUpload,
        components,
        system,
        main,
        statistics,
        outputManage,
        input,
        declaration,
        index,
        redevServices,
        redevComponents
    ])
    .config(['$urlRouterProvider', '$httpProvider', '$sceDelegateProvider', appConfig]) // "chosenProvider",
    .controller('mainCtrl', mainCtrl)
    .run(['$rootScope', '$state', '$stateParams', function runBlock ($rootScope, $state, $stateParams) {
        $rootScope.$state = $state
        $rootScope.$stateParams = $stateParams
    }])
    // 覆盖angular-tree-controll 组件bug
    .directive('treeRightClick', ['$parse', function treeRightClick ($parse) {
        return function (scope, element, attrs) {
            const fn = $parse(attrs.treeRightClick)
            element.bind('contextmenu', (event) => {
                scope.$apply(() => {
                    fn(scope, { $event: event }) // go do our stuff
                })
            })
        }
    }])



// WEBPACK FOOTER //
// ./src/main.js